// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3L8XD","tabsBox":"styles_tabsBox__2NJy8","createButton":"styles_createButton__2uBHy"};